// extracted by mini-css-extract-plugin
export default {"small":"ButtonSmall_small__ft4t7","violet":"ButtonSmall_violet__qoWqw","white":"ButtonSmall_white__i8BkX"};